export const initialMenuState = {
    result:1,
    lastValues: [],
    currentPage: "home"
}
//set the state to initialState here, only if nothing is passed
//the reducers hold the current state of whatever object you pass them. in this case 'initialGirlsState' 
export const menuReducer = (state = initialMenuState,action) => {
    switch(action.type){
        case "CHANGE-CURRENT-PAGE":
            state = {
                ...state,//this will grab everything from the previous state
                currentPage: action.payload
            };
    }
    //reducers always have to return some sort of state
    return state;
};



// WEBPACK FOOTER //
// ./src/reducers/menuReducer.js